import { Injectable } from '@angular/core';
declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class UiService {

  constructor() { }

  closeMenu() {
    $('body').toggleClass('top-header-menu-open');
    if (!$('body').hasClass('top-header-menu-open')) {
      $('body').removeClass('top-header-menu-open').addClass('top-header-menu-close');

      if ($('.top-header-container').length <= 0) {
        $('body').removeClass('top-header-menu-close');
        return;
      }

      $('.top-header-container').one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd",
        function () {
          $('body').removeClass('top-header-menu-close');
        });
    }
  }
}
